export const DRAFT_STATUS = 'draft';
export const REJECTED_STATUS = 'rejected';
export const WAITING_STATUS = 'waiting';
export const ACCEPTED_STATUS = 'accepted';
export const CLOSED_STATUS = 'closed';
